// Action types
export const SET_LANGUAGE = "SET_LANGUAGE";

// Initial state
const initialState = {
  language: localStorage.getItem("selectedLanguage") || "fr",
};

// Reducer
const languageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LANGUAGE:
      localStorage.setItem("selectedLanguage", action.payload);
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};

export default languageReducer;
